import ProtectedRoutes from "../ProtectedRoutes";
import { AdminURL } from "./AdminURL";
import AdminPageWrapper from "../../components/page_wrappers/AdminPageWrapper";

import AdminDashboard from "../../pages/admin_pages/AdminDashboard";
import AdminUsersPage from "../../pages/admin_pages/AdminUsersPage";
import AdminAllInvoicesPage from "../../pages/admin_pages/AdminAllInvoicesPage";

const routeConfigs = [
    { path: AdminURL.ADMIN_DASHBOARD, component: AdminDashboard, protected: true },
    { path: AdminURL.ADMIN_USERS, component: AdminUsersPage, protected: true },
    { path: AdminURL.ADMIN_ALL_INVOICES, component: AdminAllInvoicesPage, protected: true },
];

const AdminRoutes = routeConfigs.map(
    route => ({
        path: route.path,
        element: route.protected
        ? (
            <ProtectedRoutes>
                <AdminPageWrapper>
                    <route.component />
                </AdminPageWrapper>
            </ProtectedRoutes>
        ) : (
            <route.component />
        )
    })
);

export default AdminRoutes;
